import { Button, message } from "antd";
import React from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import * as XLSX from "xlsx"; // Import the xlsx library

export default function Excel({ column, data, fileName, comment }) {

  const generateMappedArray = (data, columns) => {
    return data.map((row) => {
      let mappedRow = {};

      // Loop through each column definition
      columns.forEach((column) => {
        // Use the column's key to extract the corresponding data field
        mappedRow[column.title] = row[column.key];
      });

      return mappedRow;
    });
  };
  const exportToExcel = () => {
    if (data.length > 0) {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();
      const exportData = generateMappedArray(data, column);

      // Convert table data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Define column widths (wch is character width)
      worksheet["!cols"] = [
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 13 },
        { wch: 10 },
        { wch: 10 },
      ];

      // Add bold styling to the first row (headers)
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C }); // Cell in the first row
        if (!worksheet[cellAddress]) continue; // Skip if cell doesn't exist

        // Apply bold style to the header cell
        worksheet[cellAddress].s = {
          font: { bold: true },
        };
      }

      const existingData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Convert sheet to array
      let updatedData = [...existingData]; // Start with the existing data
      
      if (comment) {
        const newRow = ["", ""];
        const subtotalRow = ["Note", comment];
        
        updatedData = [...existingData, [], newRow, subtotalRow]; // Append only if comment exists
      }
      
      const updatedWorksheet = XLSX.utils.aoa_to_sheet(updatedData); // Convert array back to sheet
      
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, updatedWorksheet, "Diamonds Price");
      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, "" + fileName + ".xlsx");
    } else {
      message.error("No data for export");
    }
  };

  return (
    <div>
      <Button
        icon={<RiFileExcel2Fill style={{ color: "green" }} />}
        className="orderFilter-print"
        style={{ borderRadius: "unset" }}
        onClick={exportToExcel}
      >
        EXCEL
      </Button>
    </div>
  );
}
